export default __webpack_public_path__ + "static/media/Varsun_Contact.543fee77.png";